import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';
import {
    DeviceStatus,
    deviceStatusSchema,
} from 'app/agriculture/queries/devices/types/DeviceStatus';

export interface NetworkSnapshot extends Snapshot {
    macAddress: string | null;
    typeOfNetwork: string | null;
    meshNode: boolean | null;

    connectivity: number | null;
    dataRate: number | null;
    frequency: number | null;
    latency: number | null;
    txPower: number | null;
    rssi: number | null;

    ipV6Addresses: string[] | null;
    networkAddresses: string[] | null;
    secondaryNetworkAddresses: string[] | null;
    peerMacAddresses: string[] | null;

    status: DeviceStatus;
}

export const networkSnapshotSchema = snapshotSchema.extend({
    macAddress: z.string().nullable(),
    typeOfNetwork: z.string().nullable(),
    meshNode: z.boolean().nullable(),

    connectivity: z.number().nullable(),
    dataRate: z.number().nullable(),
    frequency: z.number().nullable(),
    latency: z.number().nullable(),
    txPower: z.number().nullable(),
    rssi: z.number().nullable(),

    ipV6Addresses: z.array(z.string()).nullable(),
    networkAddresses: z.array(z.string()).nullable(),
    secondaryNetworkAddresses: z.array(z.string()).nullable(),
    peerMacAddresses: z.array(z.string()).nullable(),

    status: deviceStatusSchema,
});

export const mockNetworkSnapshot = ({
    macAddress = 'macAddress',
    typeOfNetwork = 'typeOfNetwork',
    meshNode = true,

    connectivity = 0,
    dataRate = 0,
    frequency = 0,
    latency = 0,
    txPower = 0,
    rssi = 0,

    ipV6Addresses = [],
    networkAddresses = [],
    secondaryNetworkAddresses = [],
    peerMacAddresses = [],

    status = { healthy: true, messages: [] },

    ...snapshot
}: Partial<NetworkSnapshot> = {}): NetworkSnapshot => ({
    ...mockSnapshot(snapshot),

    macAddress,
    typeOfNetwork,
    meshNode,

    connectivity,
    dataRate,
    frequency,
    latency,
    txPower,
    rssi,

    ipV6Addresses,
    networkAddresses,
    secondaryNetworkAddresses,
    peerMacAddresses,

    status,
});
